<template>
    <div>
        <h2>Please <router-link :to="'/login'" target="_blank">login here</router-link> to continue using lighty.  After you're done, please refresh your Zoom/Google Meet webpage to use lighty.<br/>Thanks!</h2>
    </div>
</template>

<script>
export default {
	mounted: function() 
    {
        window.analytics.page('Please Upgrade');
	}
}
</script>

<style scoped>

</style>
